// A session's tags: the #hashtags in its blurb, as the server parses them
// (cloudloop-flask app/blurb_tags.py, B2) so the web and the server agree
// on every shared case (tests/fixtures/blurb_tags.json).
//   #([\p{L}\p{N}_-]{1,32}), lowercased, deduplicated in order, at most 10.
// A tag longer than 32 characters is cut at 32, as the regex reads it.

export const MAX_TAGS = 10;
const TAG = /#([\p{L}\p{N}_-]{1,32})/gu;

export function parseTags(blurb) {
  if (typeof blurb !== "string" || !blurb) return [];
  const out = [];
  for (const m of blurb.matchAll(TAG)) {
    const t = m[1].toLowerCase();
    if (!out.includes(t)) out.push(t);
    if (out.length >= MAX_TAGS) break;
  }
  return out;
}

// The server's `tags` when it sends them (B2), else the blurb's.
export function sessionTags(row) {
  if (!row) return [];
  if (Array.isArray(row.tags) && row.tags.length) {
    const out = [];
    for (const t of row.tags) {
      const s = String(t || "")
        .replace(/^#/, "")
        .trim()
        .toLowerCase();
      if (s && !out.includes(s)) out.push(s);
    }
    return out.slice(0, MAX_TAGS);
  }
  return parseTags(row.blurb);
}

// A card's tag line: "#lofi #keys #rain", at most four.
export function tagLine(tags, max = 4) {
  return (tags || [])
    .slice(0, max)
    .map((t) => `#${t}`)
    .join(" ");
}
